import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TokenUserData } from '../model/token-user-data';

import {jwtDecode} from 'jwt-decode';

@Injectable()
export class TokenService {

  constructor() {}


  /**
   * Save a token locally inside the localStorage object
   * @param {string} token The token that has to be saved
   */
  saveToken(token: string): void {
    localStorage.setItem(environment.auth.localStorageKey, token);
  }

  /**
   * Get the token that is saved locally inside the localStorage object
   * @returns {string}
   */
  getToken(): string {
    return localStorage.getItem(environment.auth.localStorageKey);
  }

  /**
   * Delete the token that is saved locally inside the localStorage object
   */
  deleteToken(): void {
    localStorage.removeItem(environment.auth.localStorageKey);
  }

  /**
   * Decode the token that is saved locally inside the localStorage object
   * @param {string} token The token that has to be decoded
   * @returns {any} The decoded token
   */
  decodeToken(token: string): TokenUserData {
    return <TokenUserData> jwtDecode(token);
  }

}
